import React, { useEffect, useState } from 'react';
import AuthRequiredState from './AuthRequiredState';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [hasToken, setHasToken] = useState(() => Boolean(localStorage.getItem('token')));

  useEffect(() => {
    const syncAuthState = () => {
      setHasToken(Boolean(localStorage.getItem('token')));
    };

    window.addEventListener('auth-change', syncAuthState);
    window.addEventListener('storage', syncAuthState);

    return () => {
      window.removeEventListener('auth-change', syncAuthState);
      window.removeEventListener('storage', syncAuthState);
    };
  }, []);

  if (!hasToken) {
    return <AuthRequiredState />;
  }

  return children;
};

export default ProtectedRoute;
